import axios from 'axios'

const API = axios.create({
  baseURL: process.env.REACT_APP_I18N_URL || 'http://localhost:4000'
})

export const getDict = async () => await API.get('/?admin=true')
